import React, { useState } from 'react';
import { Box } from '@mui/material';
import BulkQueryForm from '../components/BulkQuery/BulkQueryForm';
import BulkQueryResults from '../components/BulkQuery/BulkQueryResults';

const BulkQueryPage = () => {
  const [results, setResults] = useState(null);
  
  const handleResultsReceived = (data) => {
    setResults(data);
  };
  
  return (
    <Box>
      <BulkQueryForm onResultsReceived={handleResultsReceived} />
      <BulkQueryResults results={results} />
    </Box>
  );
};

export default BulkQueryPage;
